// extracted by mini-css-extract-plugin
export default {"content":"content__jRWZaG","card":"card__xeYtKq"};